module.exports = __webpack_public_path__ + "static/img/about1.be80aba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about1.png
// module id = EMSt
// module chunks = 0